import React from "react";
import LogoWibof from "../../assets/identity/logo-wibof.png";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <nav className="bg-[#3A538C] w-full z-20 top-0 left-0 absolute">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-center md:justify-between lg:justify-between mx-auto p-4">
        <Link className="flex items-center" to={"/"}>
          <img src={LogoWibof} className="h-10 mr-3" alt="wibof logo" />
        </Link>
        <div className="flex md:order-2 lg:mt-0 mt-2">
          <div className="">
            <a
              href="https://app.wibof.com/login"
              target="_blank"
              type="button"
              className="text-white bg-[#F97F64] focus:outline-none font-medium rounded-full text-sm px-4 py-2 text-center mr-3 "
            >
              Iniciar sesión
            </a>
            <a
              href="https://app.wibof.com/account-type"
              target="_blank"
              type="button"
              className="text-white border border-white focus:outline-none font-medium rounded-full text-sm px-4 py-2 text-center mr-3 "
            >
              Crear cuenta
            </a>
          </div>
          <button
            data-collapse-toggle="navbar-sticky"
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden"
            aria-controls="navbar-sticky"
            aria-expanded="false"
          >
            <span className="sr-only">Abrir menú</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
        </div>
        <div
          className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
          id="navbar-sticky"
        >
          <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg  md:flex-row md:space-x-8 md:mt-0 md:border-0">
            <li>
              <a
                href="#home"
                className="block py-2 pl-3 pr-4 text-white rounded md:bg-transparent hover:opacity-60 md:p-0 "
                aria-current="page"
              >
                Inicio
              </a>
            </li>
            <li>
              <a
                href="#about"
                className="block py-2 pl-3 pr-4 text-white rounded md:hover:bg-transparent hover:opacity-60 md:p-0"
              >
                Nosotros
              </a>
            </li>
            <li>
              <a
                href="#features"
                className="block py-2 pl-3 pr-4 text-white rounded md:hover:bg-transparent hover:opacity-60 md:p-0"
              >
                Descargar
              </a>
            </li>
            <li>
              <a
                href="#questions"
                className="block py-2 pl-3 pr-4 text-white rounded md:hover:bg-transparent hover:opacity-60 md:p-0"
              >
                Preguntas
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
export default Header;
